@if(loading){<lib-spinner-overlay></lib-spinner-overlay>}

<lib-dba-mat-table tableNameId="objekt" [data]="objektList" [columnsdef]="columnsdefMain" [importButton]="false"
    [pageSize]="20" [editButton]="permissionService.ObjektSchreiben" [createButton]="permissionService.ObjektSchreiben"
    [deleteButton]="permissionService.ObjektLoeschen" [(selectedElement)]="selectedObjekt"
    (openDialog2)="OpenDialog($event)" (deleteClicked)="deleteData($event)">

    <lib-dba-mat-table-select [filter]="debitorFilter" [label]="language.debitor | translationPipe" labelProperty="Name"
        [list]="debitorfilteredList" [(value)]="selectedDebitor" [translate]="false" (valueChange)="filtersstandort()">
    </lib-dba-mat-table-select>

    <lib-dba-mat-table-select [filter]="standortFilter" [label]="language.Standort | translationPipe" labelProperty="Bezeichnung"
        [list]="standortfilteredList" [(value)]="selectedStandort" [translate]="false">
    </lib-dba-mat-table-select>    

  <lib-dba-mat-table-button title= "Drucken" [disabled]="!selectedObjekt" (click)="Berichtdrucken($event)">
  </lib-dba-mat-table-button>    
</lib-dba-mat-table>